import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Transactions from './Transactions'
import Overview from './Overview'
import ErrorLayout from './ErrorLayout'
import { TransactionRes } from '../../api/responseType'
import ContentsWrapper from '../../components/organisms/ContentsWrapper'
import useAccountDetail from '../../hooks/queries/useAccountDetail'
import MainContentDiv from '../../components/templates/MainContent'
import SearchContainer from '../../components/organisms/SearchContainer'
import Search from '../Search'
import ContentsTitle from '../../components/molecules/ContentsTitle'
import Tab from '../../components/molecules/Tab'
import TokenTransfer from './TokenTransfer'

export type TxDetails = Pick<
  TransactionRes['tx'],
  'blockCreationTime' | 'from' | 'to' | 'includedInBlock' | 'statusMsg' | 'txHash' | 'value' | 'txFee'
>

type TabType = 'overview' | 'transactions' | 'token Transfer'

export type Transactions = {
  method: string
  txIndex: number
} & TxDetails

function AccountDetails() {
  const navigate = useNavigate()
  const { address } = useParams() as { address: string }
  const { isContract } = useAccountDetail(address)
  const [selected, setSelected] = useState<TabType>(isContract ? 'transactions' : 'overview')
  const category = isContract ? 'contract' : 'address'

  useEffect(() => {
    setSelected(isContract ? 'transactions' : 'overview')
  }, [isContract])

  const onClickTab = (value: TabType) => {
    setSelected(value)
    if (value === 'overview') {
      navigate(`/account/${address}`)
    }
  }

  const tabItems = isContract
    ? [
        { text: 'transactions', onClick: () => onClickTab('transactions') },
        { text: 'token Transfer', onClick: () => onClickTab('token Transfer') },
      ]
    : [
        { text: 'overview', onClick: () => onClickTab('overview') },
        { text: 'transactions', onClick: () => onClickTab('transactions') },
        { text: 'token Transfer', onClick: () => onClickTab('token Transfer') },
      ]

  return (
    <MainContentDiv>
      <SearchContainer>
        <Search />
      </SearchContainer>
      <ContentsTitle title={category} copyText={address} />
      <Tab items={tabItems} selected={selected} />
      <ErrorLayout>
        <div>
          {selected === 'overview' ? (
            <ContentsWrapper>
              <Overview />
            </ContentsWrapper>
          ) : null}
          {selected === 'transactions' ? <Transactions /> : null}
          {selected === 'token Transfer' ? <TokenTransfer /> : null}
        </div>
      </ErrorLayout>
    </MainContentDiv>
  )
}

export default AccountDetails
